//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopScreen from '~/components/TopScreen.vue'
import FooterTop from '~/components/footer/footerTop.vue'
import ServiceBahrain from '~/components/legal/ServiceBahrain.vue'

// import PrivacyPolicy from '~/components/legal/PrivacyPolicy.vue'
// import PrivacyPolicyBR from '~/components/legal/PrivacyPolicyBR.vue'
// import CookiePolicy from '~/components/legal/CookiePolicy.vue'
// import BRCyberSecurityPolicy from '~/components/legal/BRCyberSecurity.vue'
// import ENLGPD from '~/components/legal/ENLGPD.vue'
// import BRGC from '~/components/legal/BRGovCorp.vue'
// import BRPLD from '~/components/legal/BRPrevLavDin.vue'
// import CPICert from '~/components/legal/CPICert.vue'
/* Lazy load components */
// const TermsBR = () =>
//   import(/* webpackChunkName: "RestAct" */ '@/components/legal/TermsBR.vue')
// const TermsPolicies = () =>
//   import(
//     /* webpackChunkName: "RestAct" */ '@/components/legal/TermsPolicies.vue'
//   )
const RestAct = () =>
  import(
    /* webpackChunkName: "RestAct" */ '@/components/legal/RestrictedAct.vue'
  )
const RestActBR = () =>
  import(
    /* webpackChunkName: "RestActBR" */ '@/components/legal/RestrictedActBR.vue'
  )
const RestActZH = () =>
  import(
    /* webpackChunkName: "RestActZH" */ '@/components/legal/RestrictedActZH.vue'
  )
const RestActES = () =>
  import(
    /* webpackChunkName: "RestActES" */ '@/components/legal/RestrictedActES.vue'
  )

export default {
  components: {
    TopScreen,
    FooterTop,
    // TermsPolicies,
    // PrivacyPolicy,
    // CookiePolicy,
    // BRCyberSecurityPolicy,
    // ENLGPD,
    // BRGC,
    // BRPLD,
    // RestAct,
    // RestActBR,
    // RestActZH,
    // RestActES,
    // CPICert,
    // TermsBR,
    // PrivacyPolicyBR,
    ServiceBahrain
  },
  data () {
    return {
      activeItem: 1,
      activeComponent: ServiceBahrain
    }
  },
  head () {
    return {
      title: this.$t('footer.about.legal').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  },
  computed: {
    getRestrictedActivities () {
      const component =
        this.$i18n.locale === 'zh'
          ? RestActZH
          : this.$i18n.locale === 'es'
            ? RestActES
            : this.$i18n.locale === 'pt'
              ? RestActBR
              : RestAct
      return component
    }
  },
  methods: {
    changeComponent ($event, item) {
      $event.preventDefault()
      if (item >= 1 && item <= 10 && this.activeItem !== item) {
        if (item === 1) {
          this.activeComponent = ServiceBahrain
        }
        this.activeItem = item
      }
    }
  }
}
